// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Color} from './color.js'

export class SetColor {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetColor {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetColor(bb: flatbuffers.ByteBuffer, obj?: SetColor): SetColor {
    return (obj || new SetColor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetColor(bb: flatbuffers.ByteBuffer, obj?: SetColor): SetColor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetColor()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startSetColor(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, valueOffset, 0)
  }

  static endSetColor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetColor(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset): flatbuffers.Offset {
    SetColor.startSetColor(builder)
    SetColor.addValue(builder, valueOffset)
    return SetColor.endSetColor(builder)
  }
}
